import React from "react";
import AdminSidebar from "./AdminSidebar";

const Sidebar = ({ open, onClose }) => {

  return (
    <React.Fragment>
      <AdminSidebar
            open={open}
            onClose={onClose}
          />
    </React.Fragment>
  );
};

export default Sidebar;